export enum ReplyEditAction {
  Update = 'Update',
  Create = 'Create',
  DeleteByUser = 'DeleteByUser',
  DeleteByAuthor = 'DeleteByAuthor',
  CancelEdit = 'CancelEdit',
  StartEdit = 'StartEditEdit',
  Report = 'Report',
  ActiveEdit = 'ActiveEdit',
  Pin = 'Pin',
  Unpin = 'Unpin',
}

export const ReplyConfigText = (ctxStr = '댓글') => ({
  [ReplyEditAction.Create]: `${ctxStr} 추가`,
  [ReplyEditAction.Update]: `${ctxStr} 수정`,
  [ReplyEditAction.StartEdit]: `${ctxStr} 수정`,
  [ReplyEditAction.CancelEdit]: `${ctxStr} 수정 취소`,
  [ReplyEditAction.ActiveEdit]: `${ctxStr} 수정`,
  [ReplyEditAction.DeleteByUser]: `${ctxStr} 삭제`,
  [ReplyEditAction.DeleteByAuthor]: `${ctxStr} 삭제`,
  [ReplyEditAction.Report]: '신고',
  [ReplyEditAction.Pin]: `${ctxStr} 고정`,
  [ReplyEditAction.Unpin]: `${ctxStr} 고정 해제`,
});
